<div class="block products-contrainer" [loading]="loading">
  <div class="filter">
    <gob-filter-product
      (filter)="filterProduct($event)"
      (reset)="reset()"
    ></gob-filter-product>
  </div>
  <div class="list-container">
    <div
      *ngIf="filter.gamme === GAMME_VENTE_PRIVEE"
      class="private-sale-banner"
    >
      <!-- TODO: texte provisoire, à valider avec Thibault avant mise en prod -->
      🔒 Ces produits font partie d'une <strong>vente privée</strong> en ce
      moment ! Seuls nos clients <u>inscrits</u> peuvent profiter des tarifs
      remisés. Pas encore inscrit·e ? Rejoignez le club pour ne plus rater les
      prochaines ! (Surveillez vos mails ainsi que nos réseaux sociaux pour ne
      pas rater les prochaines !)
    </div>

    <div *ngIf="!products.length && !loading" class="no-content">
      Aucun produit trouvé
    </div>

    <div *ngIf="products.length">
      <gob-list-card *ngIf="isGrid" [products]="products"></gob-list-card>
      <gob-list-line *ngIf="!isGrid" [products]="products"></gob-list-line>

      <div class="page-container">
        <gob-pagination
          [max]="max"
          (change)="next($event, filter)"
          [activePage]="page"
        ></gob-pagination>
      </div>
    </div>
  </div>
</div>

<gob-back-to-top [forceDesktop]="true"></gob-back-to-top>
